<template>
  <FightButtons
      v-if="mode === 'fight'"
      :fight="fight"
      :position-type="position.type"
      :city-id="position.city.id"
      :pokeballs="trainer.pokeballs"
      :wild="(position && position.wild && position.wild.type) ? position.wild.type : null"
      :trainer-fight="position.trainerFight"
      :is-trainer-fight="isTrainerFight"
      @recall-pokemon="$emit('recall-pokemon')"
      @choose-pokemon="$emit('choose-pokemon')"
  />
  <DungeonButtons
      v-else-if="mode === 'dungeon'"
      :fight="fight"
      :is-dungeon-challenge="isDungeonChallenge"
      :city-id="position.city.id"
      :obstacle-fight="obstacleFight"
      :wild="position.wild"
      :reset-skill="resetSkill"
      :masterballs="trainer.masterballs"
      :trainer-fight="position.trainerFight"
      :is-trainer-fight="isTrainerFight"
      :go-to-dungeon="goToDungeon"
      @recall-pokemon="$emit('recall-pokemon')"
      @choose-pokemon="$emit('choose-pokemon')"
  />
  <WildObstacleActions
      v-else-if="mode === 'wild-obstacle'"
      :position="position"
      :obstacle-fight="obstacleFight"
  />
  <EncounterActions
      v-else-if="mode === 'encounter'"
      :position="position"
  />
</template>

<script>
import FightButtons from '@/components/journey/positions/fight/FightButtons';
import DungeonButtons from '@/components/journey/positions/pieces/DungeonButtons';
import WildObstacleActions from '@/components/journey/positions/battle/WildObstacleActions';
import EncounterActions from '@/components/journey/positions/battle/EncounterActions';

// Akční lišta - dispatch podle módu (viz matice akcí x mód v claude/battle-screen-design.md).
// Znovupoužívá existující FightButtons/DungeonButtons beze změny (už dnes správně
// rozlišují wild/trenér/team rocket/liga, resp. dungeon-pokémon/dungeon-překážka
// podle vlastních props) - přepisovat jejich už fungující matici by bylo zbytečné
// riziko. Jediná skutečně chybějící akční sada byla "samostatná divoká překážka",
// dřív natvrdo v ObstacleFight.vue - ta je nová (WildObstacleActions).
export default {
  name: "BattleActions",
  components: {FightButtons, DungeonButtons, WildObstacleActions, EncounterActions},
  props: {
    mode: {type: String, required: true}, // 'fight' | 'dungeon' | 'wild-obstacle' | 'encounter'
    position: {type: Object, required: true},
    trainer: {type: Object, default: null},
    fight: {type: Object, default: null},
    obstacleFight: {type: Object, default: null},
    isTrainerFight: {type: Boolean, default: false},
    isDungeonChallenge: {type: Boolean, default: false},
    goToDungeon: {type: Function, default: () => {}},
    resetSkill: {type: Function, default: () => {}},
  },
}
</script>
